import Vue from 'vue';

export default {
    name: 'home-route',
    async handle(to, from, next) {
        await Vue.state.client.ensure();
        const homeRoute = Vue.state.client.get().view.routing.homeRoute;
        if (homeRoute && to.path === '/' && to.name != homeRoute) {
            next({ name: homeRoute });
            return true;
        }
        return false;
    }
};



// WEBPACK FOOTER //
// ./_common/routehandlers/home-route.routehandler.js